// extracted by mini-css-extract-plugin
export var active_nav_link = "styles-module--active_nav_link--6f939";
export var banner_section = "styles-module--banner_section--58c99";
export var big_nav = "styles-module--big_nav--7ebe5";
export var big_nav_case_studies_img = "styles-module--big_nav_case_studies_img--7846c";
export var big_nav_contact_us_img = "styles-module--big_nav_contact_us_img--eccf3";
export var big_nav_services_img = "styles-module--big_nav_services_img--b5593";
export var blinker = "styles-module--blinker--77d27";
export var booking_iframe = "styles-module--booking_iframe--39578";
export var booking_section = "styles-module--booking_section--857a6";
export var call_now = "styles-module--call_now--ad319";
export var case_studies = "styles-module--case_studies--89a51";
export var case_study_myer = "styles-module--case_study_myer--578e5";
export var clients = "styles-module--clients--dd5fc";
export var clients_group = "styles-module--clients_group--7905b";
export var contact_details = "styles-module--contact_details--6cb74";
export var contact_phone = "styles-module--contact_phone--e037c";
export var contact_us = "styles-module--contact_us--7f2cd";
export var cookiemonster = "styles-module--cookiemonster--bbd6c";
export var cookiemonster_buttons = "styles-module--cookiemonster_buttons--66102";
export var cookiemonster_buttons_accept = "styles-module--cookiemonster_buttons_accept--9ef26";
export var cookiemonster_buttons_choose = "styles-module--cookiemonster_buttons_choose--74f7c";
export var cookiemonster_buttons_decline = "styles-module--cookiemonster_buttons_decline--3bcd4";
export var cookiemonster_cookie_list = "styles-module--cookiemonster_cookie_list--037df";
export var dark = "styles-module--dark--62bf6";
export var dark_mode_switch = "styles-module--dark_mode_switch--d3f57";
export var dark_only = "styles-module--dark_only--0ab7a";
export var hero = "styles-module--hero--0299f";
export var hide_on_mobile = "styles-module--hide_on_mobile--24bf4";
export var home_cta = "styles-module--home_cta--59e08";
export var home_cta_flat = "styles-module--home_cta_flat--f37e6";
export var home_cta_wide = "styles-module--home_cta_wide--8f1c8";
export var image_wrap = "styles-module--image_wrap--ddd94";
export var index_banner = "styles-module--index_banner--f38cd";
export var index_fit = "styles-module--index_fit--6fe2e";
export var language_selector = "styles-module--language_selector--6888e";
export var light = "styles-module--light--1bc05";
export var light_only = "styles-module--light_only--af2d7";
export var link_tag = "styles-module--link_tag--f4877";
export var mobile_only = "styles-module--mobile_only--16b0f";
export var nav_controls = "styles-module--nav_controls--3f212";
export var nav_controls_darkmode = "styles-module--nav_controls_darkmode--b5df1";
export var nav_lang_item = "styles-module--nav_lang_item--d4ece";
export var nav_logo_section = "styles-module--nav_logo_section--4ea8a";
export var nav_open = "styles-module--nav_open--0b054";
export var nav_section = "styles-module--nav_section--38399";
export var nav_sep = "styles-module--nav_sep--5599e";
export var partners = "styles-module--partners--db891";
export var popover_banner = "styles-module--popover_banner--a1dc1";
export var popover_container = "styles-module--popover_container--0e296";
export var privacy_policy = "styles-module--privacy_policy--fb082";
export var section_footer = "styles-module--section_footer--c3a69";
export var services = "styles-module--services--5d3c3";
export var services_intro = "styles-module--services_intro--e88f7";
export var square_box = "styles-module--square_box--65c61";
export var square_box_3 = "styles-module--square_box_3--5bfe9";
export var square_box_4 = "styles-module--square_box_4--99ce1";
export var square_column = "styles-module--square_column--630c8";
export var square_container = "styles-module--square_container--2afbb";
export var square_row = "styles-module--square_row--cd8c2";
export var with_popover = "styles-module--with_popover--534c6";